import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgComponent } from 'icon';
import { PCProduct } from 'product';
import { TranslatePipe } from 'translate';

@Component({
  selector: 'lib-table-home-internet',
  standalone: true,
  imports: [SvgComponent, TranslatePipe],
  templateUrl: './table-home-internet.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableHomeInternetComponent {
  @Input() product: PCProduct;
}
